import { Component, OnInit, HostListener } from '@angular/core';
import { RecruiterAuthenticationService } from '../services/recruiter-authentication.service';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { DashboardComponent } from '../recruiter/dashboard/dashboard.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './recruiter-layout.component.html'
})
export class RecruiterLayoutComponent implements OnInit {

  public disabled: boolean = false;
  public status: {isopen: boolean} = {isopen: false};
  public loggedUser = localStorage.getItem("username");
  public currentUser = JSON.parse(localStorage.getItem("user"));
  clients;
  clientid;
  companyname;
  clientname = (this.currentUser.mappedClient) ? this.currentUser.mappedClient : "select";
  clinetNameText = null;
  userId = this.currentUser.id;
  public randVal  = +new Date;
  headerText = null;
  currentPage = null;

  constructor(private authService : RecruiterAuthenticationService,
              private userService: UserService,
              private router: Router,
              private recruiterDashboard: DashboardComponent) { 
              //  console.log(this.currentUser);
    this.userService.getUserName.subscribe(user => this.changedUser(user));   
    this.userService.getUsers('client')
      .then(
        (response) => {
          this.clients = response.json().Result;         
          if(this.clientname != "select") {
            this.clinetNameText = this.clients.filter(client => client.id == this.clientname)[0].companyName;
            localStorage.setItem("selectedClientName", this.clinetNameText);
          } else {
            this.clinetNameText = "";
          }
        });  
    
    this.userService.getHeaderText.subscribe(headerText => {
      this.headerText =  headerText;
    });
    this.userService.getUrlname.subscribe(urlName => {
      this.currentPage =  urlName;
    });
  }

  @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent): void {      
    document.querySelector('.dropdown').classList.remove('open');   
   // document.querySelector('.select-usertype').classList.remove('open');
  }
  
  public toggleDropdown($event: MouseEvent): void {    
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
    document.querySelector('.dropdown').classList.toggle('open');     
  } 

  public selectUserType($event: MouseEvent): void {    
    $event.preventDefault();
    $event.stopPropagation();
   // document.querySelector('.select-usertype').classList.toggle('open');     
  } 

  setClietSesion(clientId, clientName) {        
    this.userService.updateLastSelectedClient(this.userId, {"lastSelectedClient": clientId})
        .subscribe(          
          (response) => {
            if(response.json().StatusCode == 200) {
              this.currentUser = JSON.parse(localStorage.getItem("user"));
              this.currentUser.lastSelectedClient = clientId; 
              localStorage.setItem("user", JSON.stringify(this.currentUser));
              localStorage.setItem("selectedClient", clientId);
              localStorage.setItem("selectedClientName", clientName);
              // if(obj.value == "select") {
                // this.router.navigate(['recruiter/dashboard']);
              // } else {
              //   this.refresh();
              // }
              this.clinetNameText = clientName;
              this.userService.clientChanged();
              // if(currentPage == "update-talent") {
               this.router.navigate(['recruiter/dashboard']);
              // }
            }
          },
          (error) => {
            console.log(error);
            this.refresh();
          }
        );     
  }

  public logOut() {   
    this.authService.logout();
  }

  ngOnInit(): void { 
    
  }

  refresh(): void {
    window.location.reload();
  }

  private changedUser(user): void {
    this.currentUser = user;
    this.randVal  = +new Date;
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/recruiter-layout.component.ts